var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',{attrs:{"message":_vm.message}},[_c('template',{slot:"primary"},[_c('toggle',{attrs:{"value":_vm.isChecked,"messages":_vm.toggleLabels},on:{"input":_vm.onInput}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }